import { render, staticRenderFns } from "./contentInsights.vue?vue&type=template&id=309b3d09"
import script from "./contentInsights.vue?vue&type=script&lang=js"
export * from "./contentInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports